
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const FinancingSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">💳 Financing Available</h2>
            <p className="text-gray-600">Flexible Payment Options | Easy Approval Process</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinancingSection;
